import {Location} from 'react-router-dom';

export function urlIsBasePath(location: Location, path: string): boolean {
    return location.pathname == path || location.pathname.startsWith(path + '/')
}